const PRE_FIX = 'SPERO_APP_H5_'
export default {
  PRE_FIX,
  DEVICE_ID: PRE_FIX + 'DEVICE_ID',
  DEVICE_NAME: PRE_FIX + 'DEVICE_NAME',
  DISTINCT_ID: PRE_FIX + 'DISTINCT_ID'
}



// WEBPACK FOOTER //
// ./src/constants/anonymity-login.js